import { Select } from '../select';
import { sepaCountries } from './SepaCountries';
import styles from './SepaCountrySelector.module.css';
import { Item } from '../select/Select';
import React, { useState, useEffect, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface  SepaCountryLabel {
    icon: ReactNode;
    key: string;
}

interface SepaCountrySelectorProps {
  value: string;
  onChange?: (value: string) => void;
}

const SepaCountrySelector = ({ value, onChange }: SepaCountrySelectorProps) => {
    const { t } = useTranslation();
    const [selectedItem, setSelectedItem] = useState<string>(value);
    const countries = sepaCountries();

    const renderSepaCountryLabel = (item: SepaCountryLabel) => {
        return (
            <div className={styles.sepaCountryLabel}>
                {item.icon}
                <span>{item.key}</span>
            </div>
        )
    }

    const sortedCountries = [...countries]
        .sort((a, b) => {
            const keyA = a.label.key.toLowerCase();
            const keyB = b.label.key.toLowerCase();
            return keyA.localeCompare(keyB);
        })
        .map(item => ({
            value: item.value,
            label: renderSepaCountryLabel(item.label),
        }));

    useEffect(() => {
        const found = countries.find((item) => item.value === value);
        if (found) {
            setSelectedItem(found.value);
        }
    }, [value]);

    const handleCountryChange = (item: Item) => {
        setSelectedItem(item.value);
        onChange?.(item.value);
    };

    return (
        <Select
            name='sepaCountrySelector'
            placeholder={t('screening.incomeVerification.provideTransactions.countrySelector.placeHolder')}
            required={true}
            label={t('screening.incomeVerification.provideTransactions.countrySelector.label')}
            selected={selectedItem}
            items={sortedCountries}
            onChange={handleCountryChange}
            fullWidth={true}
            subText={t('screening.incomeVerification.provideTransactions.countrySelector.subText')}
        />
    );
};

export default SepaCountrySelector;
